<template>
    <div>
        <vue-dropzone id="dropzoneId" ref="dropzoneRef"
                      :class="{'reader-view': !authenticated, 'edit-view': authenticated}"
                      :options="dropzoneOptions"
                      @vdropzone-mounted="dropzoneMounted"
                      @vdropzone-removed-file="removeFile"
                      @vdropzone-success="dropzoneSuccess"></vue-dropzone>
    </div>
</template>

<script>
//    import { uuid } from 'vue-uuid'
    import vueDropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        name: 'ImageEditor',
        props: ['imageIds', 'refId', 'imageType', 'maxFiles'],
        components: {
            vueDropzone
        },
        data: function(){
        return {
            dropzoneOptions: {
                url: this.$store.getters.imageURL,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                //maxFilesize: 5.0,
                maxFiles: this.maxFiles,
                acceptedFiles: '.jpg,.jpeg,.png',
                addRemoveLinks: this.$store.getters.isAuthenticated,
                dictDefaultMessage: 'Bilder hochladen',
                dictCancelUpload: 'Abbruch',
                dictUploadCanceled: 'Abburch',
                dictCancelUploadConfirmation: 'Abbruch bestätigen,',
                dictRemoveFile: 'Löschen',
                withCredentials:true,
                resizeWidth: 1024,
                params: {
                    imagetype: this.imageType,
                    refid: this.refId,
                    },
            },
            images : null
        }},
        computed: {
            filteredImages() {
                if (!this.imageIds || this.imageIds.length <= 0) {
                    return []
                }

                return this.$store.getters.imageList.filter(image => {
                    return this.imageIds.includes(image.id)
                })
            },
            authenticated() {
                return this.$store.getters.isAuthenticated
            }
        },
        methods: {
            dropzoneMounted() {
                //fixes problem when there is an unsaved image in DB and no refid given.
                if(this.refId===null) {
                    this.images = []
                    return;
                }
                this.$http.get('/image/'+this.imageType+'/'+this.refId)
                    .then(response=>{
                            console.log('Loading Images');
                            console.log(response);
                            this.images = response.data

                            this.images.forEach(image => {
                                let mockfile = { name: image.filename, size: 50000, id:image.id}
                                let path = 'https://neos.crellutions.at'+image.path + '/' + image.filename;
                                console.log(path)
                                this.$refs.dropzoneRef.manuallyAddFile(mockfile, path)
                            })
                        });
                /*
                                return

                                if (!this.imageIds || this.imageIds.length <= 0) {
                                    return
                                }

                                let result = this.$store.getters.imageList.filter(image => {
                                    return this.imageIds.includes(image.id)
                                })

                                for (let item of result) {
                                    let file = {
                                        name: item.id + ".png",
                                        id:item.id,
                                        type: "image/png",
                                        dataURL: item.src,
                //Size is necessary
                                        size:2
                                    }

                                    this.$refs.dropzoneRef.manuallyAddFile(file, file.dataURL)
                //                    this.$refs.dropzoneRef.dropzone.emit('thumbnail', file, file.dataURL)
                                    this.$emit('image-editor-upload', item.id)
                //                    this.$refs.dropzoneRef.dropzone.emit('success', file)
                                }*/
            },
            dropzoneSuccess(imageBlob, response){//}, response) {
                console.log(imageBlob)
                console.log(response.id)
                imageBlob.id = response.id;
//                console.log(response)
                console.log("SUCCCESSS")
                // Create image instance
/*                let image = {
                    id: uuid.v1(),
                    blob: imageBlob,
                    //FIXME dbid aus mysql, alles weglöschen was man nicht braucht.
//                    db_id: response['fileid']
                }

                console.log(`[ImageEditor] Image instance: ${JSON.stringify(image)}`)

                // Store image remote
                this.$store.dispatch('uploadImage', image)
                // Notify parent component
                this.$emit('image-editor-upload', image.id)
                */
            },
            removeFile(file, error, xhr){
                console.log("REMOVE")
                console.log(file)
                console.log(error)
                console.log(xhr)
//                this.$emit('image-editor-delete', file.id)
                console.log(this.$refs.dropzoneRef.getAcceptedFiles())
                console.log(this.$refs.dropzoneRef.getRejectedFiles())
            },
            /**
             *
             * @returns {boolean}
             */
            saveState(){
                console.log("activeImage")

                console.log('inactivate any image')

                //set every image to 0 to be sure any image is "deleted"
                this.images.forEach(image => {
                    console.log('Set files mit id'+image.id+'inactive')
                    image.active = 0;
                })
                this.$http.patch('/image', this.images);

                console.log('set active images')

                //reactive remaining images in DB
                let activeImages = this.$refs.dropzoneRef.getAcceptedFiles()
                activeImages = activeImages.concat(this.$refs.dropzoneRef.getRejectedFiles())
                activeImages.forEach(image => {
                    console.log('Set files mit id'+image.id+'active')
                    console.log(image)
                    image.active = 1;
                })

                this.$http.patch('/image', activeImages)
            }

        },
        mounted() {
            console.log('mounted NEW ImageEditor');
        },
        watch: {
            refId: function (){
                this.dropzoneOptions.params.refid = this.refId
            }
        }
    };
</script>

<style lang="scss">
    #dropzoneId .dz-remove {
        //color: #fa323d;
        color: white;
        border-color: white;
        border-width:0;
        background-color:#fa323d;
        width:100%;
        margin:0;
        border-radius: 2px;
    }
    #dropzoneId .dz-error-mark{
        background-color: red;
    }

    #dropzoneId .dz-details{
        background-color: transparent;
    }
    #dropzoneId .dz-details>* {
        display:none
    }
    #dropzoneId .dz-image{
        z-index:initial;
    }
</style>
